import Enumeration from 'Lib/utilities/Enumeration';

const StartedApplicationStatuses = new Enumeration([
    { id: 1, key: 'Started', name: 'In progress', icon: 'autorenew', color: '#6e66ff' },
    { id: 2, key: 'Complete', name: 'Completed', icon: 'check', color: 'green' },
    { id: 3, key: 'Pending', name: 'Not started', icon: 'close', color: 'grey' },
    { id: 4, key: 'DeactivatedUnit', name: 'Deactivated Unit', icon: 'cancel', color: 'error' }
]);

export default StartedApplicationStatuses;
